import { Dialog, DialogContent, Divider } from "@material-ui/core";
import React from "react";
import { Loading } from "react-admin";
export const LoadingPopup = ({ loading }) => {
  return (
    // <Grid>
    <Dialog open={loading}>
      <Divider />
      <DialogContent>
        <Loading loadingPrimary={"Please Wait!"} loadingSecondary={"This process may take a few minutes"} />
      </DialogContent>
    </Dialog>
    // </Grid>
  );
};
export default LoadingPopup;
